import { useContext } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";

import { TenantContext } from "@nens/ranalib";
import { SubmitFunction } from "@nens/ranalib";

import { useCreateNewProject } from "../api/create-project";
import { ProjectFormValues } from "../types/project-form-values";
import { validateProject } from "../utils/project-validation";

export function useTenantNewProject() {
  const { tenant } = useContext(TenantContext);

  const intl = useIntl();

  const projectListUrl = `/${tenant}/projects`;
  const navigate = useNavigate();
  const { isMutating, mutate } = useCreateNewProject();

  const validate = (values: ProjectFormValues) => validateProject(values, intl);

  // Submit can assume validate returned no errors.
  const submit: SubmitFunction<ProjectFormValues> = (values, onError) => {
    const name = values.name + "";
    const code = values.code + "";
    const description = values.description + "";
    const location = values.location?.geometry;
    const locationName = values.location?.properties?.name;

    const project = {
      name,
      code,
      description,
      location,
      locationName,
    };
    mutate(project, {
      onSuccess: async ({ slug }) => {
        navigate(`/${tenant}/projects/${slug}`);
      },
      onError,
    });
  };

  return { projectListUrl, validate, submit, isMutating };
}
